module.exports = __webpack_public_path__ + "img/manufacture@2x.f3bdd22.webp";